module.exports = __webpack_public_path__ + "f79f27b90112a626972434bc16f81ec6.pdf";